import React, { useEffect, useState } from 'react'

function ImagePreview({ 
  fileInputId, 
  previewType,
  existingImageUrl = null,
  existingImageAlt = ''
}) {
  const [previewUrl, setPreviewUrl] = useState(existingImageUrl)
  const [showPreview, setShowPreview] = useState(!!existingImageUrl)

  useEffect(() => {
    const fileInput = document.getElementById(fileInputId)
    if (!fileInput) {
      console.error(`File input with id ${fileInputId} not found`)
      return
    }

    const handleFileChange = (e) => {
      const file = e.target.files[0]
      
      if (file) {
        const reader = new FileReader()
        reader.onload = (readerEvent) => {
          setPreviewUrl(readerEvent.target.result)
          setShowPreview(true)
        }
        reader.readAsDataURL(file)
      } else {
        // If no file selected, revert to existing image or hide preview
        setPreviewUrl(existingImageUrl)
        setShowPreview(!!existingImageUrl)
      }
    }

    fileInput.addEventListener('change', handleFileChange)

    // Cleanup
    return () => {
      fileInput.removeEventListener('change', handleFileChange)
    }
  }, [fileInputId, existingImageUrl])

  if (!showPreview) {
    return null
  }

  return (
    <div id={`${previewType}-image-preview`} className="mt-2">
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Preview:</p>
      <img
        id={`${previewType}-image-preview-img`}
        src={previewUrl}
        alt={existingImageAlt || 'Preview'}
        className="max-w-full h-auto rounded-md border border-gray-300 dark:border-gray-600"
        style={{ maxHeight: '200px' }}
      />
    </div>
  )
}

export default ImagePreview